export default __webpack_public_path__ + "static/media/upcoming_30_plus_blue.5def1e28.svg";